<div>
  <div mat-dialog-content>
    <p>{{data.message}}</p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-flat-button color="warn" (click)="onNoClick('yes')">Yes</button>
    <button mat-flat-button (click)="onNoClick('no')">No</button>
  </div>
</div>